/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, useEffect, useState } from 'react';
import { Field, useFormikContext, getIn } from 'formik';
import { DropdownMenu, TextInput, CheckboxInput } from '@components';
import gridFormStyles from '@pages/forms/Grid.module.scss';
import PhoneIcon from '../../images/phone.svg';

interface iProps {
  name: string;
  numberTypeMandatory?: boolean;
  secondaryContact: boolean;
  hasPrimaryNumberType?: boolean;
  hasSecondaryNumberType?: boolean;
  noContactFieldName?: string;
  noContactFieldRequired?: boolean;
  currentSP?: string;
}

const ContactInput = ({ name, numberTypeMandatory = true, secondaryContact, hasPrimaryNumberType = true, hasSecondaryNumberType = true, noContactFieldName = '', noContactFieldRequired = true, currentSP = '' }: iProps): ReactElement => {
  const [disableContactlInput, setContactInput] = useState(false);
  const formikContext = useFormikContext();
  const CONTACT_OPTIONS = [
    { value: 'Mobile', display: 'Mobile' },
    { value: 'Work', display: 'Work' },
    { value: 'Home', display: 'Home' },
  ];

  useEffect(() => {
    if (noContactFieldName) {
      setContactInput(getIn(formikContext.values, noContactFieldName));
    }
  }, []);

  return (
    <div className={gridFormStyles.form}>
      <div className={gridFormStyles.gridColHalf}>
        <Field name={`${name}.ContactNumber`} component={TextInput} title="Contact phone number" icon={PhoneIcon} type="tel" isMandatory disabled={disableContactlInput} />
        {hasPrimaryNumberType && (
          <Field name={`${name}.NumberType`} component={DropdownMenu} title="Number type" displayText={CONTACT_OPTIONS} defaultOption isMandatory={numberTypeMandatory} />
        )}
        {noContactFieldRequired && currentSP && (
          <>
            <br />
            <Field
              name={noContactFieldName}
              component={CheckboxInput}
              title={currentSP}
              boxChecked={(e: boolean) => {
                setContactInput(e);
                formikContext.setFieldTouched(name, false);
                formikContext.setFieldValue(name, '');
              }}
            />
          </>
        )}
      </div>
      {secondaryContact && (
        <div className={gridFormStyles.gridColHalf}>
          <Field name={`${name}.SecondaryContactNumber`} component={TextInput} title="Secondary phone number" icon={PhoneIcon} type="tel" />
          {hasSecondaryNumberType && (
            <Field
              name={`${name}.SecondaryNumberType`}
              component={DropdownMenu}
              title="Number type"
              displayText={CONTACT_OPTIONS}
              defaultOption
              isMandatory={numberTypeMandatory}
              isOptional
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ContactInput;
